// var breadcrumb_shop_page = jQuery('.fusion-breadcrumbs>span>span>span>a').html();
// if (breadcrumb_shop_page == 'ShopPage') {
//     jQuery('.fusion-breadcrumbs>span>span>span>a').replaceWith('');
// }

jQuery( "#filterButton" ).click(function() {
    jQuery('#sidebar').addClass('open');
    jQuery('#sidebar-product-search').addClass('open');
});


jQuery( ".sidebarClose" ).click(function() {
    jQuery('#sidebar').removeClass('open');
    jQuery('#sidebar-product-search').removeClass('open');
});



// document.getElementsByClassName("wpfFilterButton")[0].onclick = function() {filterFunction()};
//
// function filterFunction() {
//   alert( "test" );
// }


jQuery( ".wpfFilterButton" ).click(function() {
    jQuery('#sidebar').removeClass('open');
    jQuery('#sidebar-product-search').removeClass('open');
});
